<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../../assets/images/banner_intro.jpg" />
            <div class="btext">
                <h3>平台优势</h3>
                <p>以客户为本，真诚服务，持续创新，追求卓越</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>平台概况</el-breadcrumb-item>
                <el-breadcrumb-item>平台优势</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>

                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="4"
                            class="el-menu-vertical-demo"
                    >
                        <router-link :to="{ path: '/centerIntroduce' }">
                            <el-menu-item index="1"><span slot="title" >平台简介</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/serviceScope' }">
                            <el-menu-item index="2"><span slot="title">服务模式</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/managementAim' }">
                            <el-menu-item index="3"><span slot="title">经营宗旨</span></el-menu-item>
                        </router-link>

                        <router-link :to="{ path: '/platformAdvantage' }">
                            <el-menu-item index="4"><span slot="title">平台优势</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/organizationalStructure' }">
                            <el-menu-item index="5"><span slot="title">组织架构</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>

                <el-col :span="19">
                    <div class="con_right">
                        <div class="con">
                            <div v-html="this.content">

                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {reqPlatformAdvantageList} from '../../../api/contentManagement-api'
    export default {
        data(){
            return{
                content:'',
            }
        },
        methods:{
            getPlatformAdvantage(){
                reqPlatformAdvantageList().then((res)=>{
                    if(res.data.code===1){
                        this.content=res.data.data[0].content;
                    }else{
                        this.content='<p>抱歉，暂无数据</p>'
                    }
                })

            }
        },
        mounted(){
            this.getPlatformAdvantage();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/contentManagement/centerSituation/platformAdvantage.vue